export async function uploadFile(file, url, callback) {
    const formData = new FormData();
    formData.append('file', file.file);

    file.status = 'loading';

    let response

    try {
        response = await axios.post(url, formData);
    } catch (error) {
        file.status = 'fail';
        file.error = error.response.data.errors.file[0] || null
        return false;
    }

    file.status = response.status === 200 ? 'success' : 'fail';

    callback(response)

    return response;
}

export function uploadFiles(files, url, callback) {
    return Promise.all(files.map((file) => uploadFile(file, url, callback)));
}

export default function createUploader(url, callback) {
    return {
        uploadFile: function (file) {
            return uploadFile(file, url, callback);
        },
        uploadFiles: function (files) {
            return uploadFiles(files, url, callback);
        },
    }
}
